"use client";

import React, {
  createContext,
  useState,
  useEffect,
  useContext,
  ReactNode,
} from "react";
import Cookies from "js-cookie";

interface SiteAuthContextProps {
  isAuthenticated: boolean;
  loading?: boolean;
}

let SiteAuthContext: React.Context<SiteAuthContextProps | undefined>;

if (typeof window !== "undefined") {
  // Create context only on the client side
  SiteAuthContext = createContext<SiteAuthContextProps | undefined>(undefined);
} else {
  // For server-side rendering or build processes, create a dummy context
  SiteAuthContext = createContext<SiteAuthContextProps | undefined>({
    isAuthenticated: false,
  });
}

export const SiteAuthProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verifyToken = async () => {
      setLoading(true);
      let token;

      token = Cookies.get("site-auth-token");

      if (token) {
        try {
          const response = await fetch(
            "https://backend-site-auth.onrender.com/api/v1/auth-external/verify",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ token }),
            }
          );
          const data = await response.json();
          if (data.success) {
            setIsAuthenticated(true);
          } else {
            console.log("Token verification failed:", data);
            Cookies.remove("site-auth-token");
          }

          setLoading(false);
        } catch (error) {
          console.error("Token verification failed:", error);
          Cookies.remove("site-auth-token");
        }
      }

      setLoading(false);
    };

    verifyToken();
  }, []);

  return (
    <SiteAuthContext.Provider value={{ isAuthenticated, loading }}>
      {children}
    </SiteAuthContext.Provider>
  );
};

export const useSiteAuth = () => {
  const context = useContext(SiteAuthContext);
  if (!context) {
    throw new Error("useSiteAuth must be used within a SiteAuthProvider");
  }
  return context;
};
